<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header">
        <h6>Отчет за день</h6>
      </div>
      <div class="card-body">
        <div class="flex justify-content-between">
          <div>
            <DateSelect
              v-if="selectedDate"
              ref="selectedDate"
              :disabled="true"
              :onSelect="updateSelectedDate"
              :selectedDate="selectedDate"
              :dateRange="dateRange"
            />
          </div>
          <LoadingButton
            title="Показать"
            type="button"
            :loading="loading"
            :color="$constants.SUCCESS_COLOR"
            :onClick="() => showReport()"
            className="btn btn-outline-success"
          />
        </div>
      </div>
    </div>
    <div class="report_block" v-if="reportLoaded">
      <div :class="{loading_block: true, active: loading}"></div>
      <div class="card">
        <div class="card-body flex justify-content-between flex_gap_10">
          <div v-if="!loading">
            <Saldo
              ref="saldo"
              :division="selectedDivision"
              :hideYesterday="true"
              :balance="balance"
              :expenses="expenses"
              :incomes="incomes"
              :exchanges="[]"
              :orders="orders"
            />
            <p v-if="ncAmount">
              ИТОГО без подтвержденных инкассаций: <strong>{{
                ((balance?.dayOffSum ?? 0) - ncAmount).toLocaleString('ru-RU')
              }}</strong>
            </p>
            <Calculation
              ref="balanceCalculation"
              v-if="balance"
              :useCashOut="false"
              :balance="balance"
              :noCashOrders="[]"
              :division="selectedDivision"
              :divisions="[]"
              :dayData="reportData"
              :expenses="expenses"
              :incomes="incomes"
              :refreshReport="showReport"
              :exchanges="reportData.exchanges ?? []"
              :orders="[]"
            />
          </div>
          <div>
            <p v-if="ncAmount"><strong>Инкассации без подтверждения</strong></p>
            <NonConfirmedIncomes
              :records="balance?.nonConfirmedIncomes"
              hideReject="true"
              confirmStatus="2"
            />
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <h6>Расходы</h6>
        </div>
        <div class="card-body p-t-1">
          <ExpensesBlock
            :expenses="expenses"
            :types="expensesTypes"
            :division="selectedDivision"
            :currencies="allowedCurrencies"
            :userId="$currentUID"
            :users="{}"
            :date="selectedDate"
            :notConfirmedExpenses="true"
            :updateExpenses="(r) => expenses = r"
          />
        </div>
      </div>

      <div class="card" v-if="false && checkPermission('allowToBuyCurrency')">
        <div class="card-header">
          <h6>Покупка валюты</h6>
        </div>
        <div class="card-body p-t-1">
          <CurrencyExchangeBlock
            :records="exchanges"
            :disableToSaveRate="true"
            :currencies="allowedCurrencies"
            :date="selectedDate"
            :userId="$currentUID"
            :division="selectedDivision"
            :updateRecords="updateExchanges"
          />
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <h6>Инкассации</h6>
        </div>
        <div class="card-body p-t-1">
          <IncomesBlock
            ref="IncomesBlock"
            :records="incomes"
            :date="selectedDate"
            :receivers="getAllowedReceivers()"
            :userReceivers="getAllowedReceivers('allowed_cashout_to_users')"
            :userId="$currentUID"
            :users="{}"
            :useConfirm="true"
            :division="selectedDivision"
            :updateReport="() => showReport(null, null, true)"
          />
        </div>
      </div>

    </div>
  </div>
</template>

<script>

import DateSelect from "@/views/reports/components/DateSelect.vue";
import moment from "moment";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import api from "@/api";
import ExpensesBlock from "@/views/reports/components/ExpensesBlock.vue";
import IncomesBlock from "@/views/reports/components/IncomesBlock.vue";
import Saldo from "@/views/reports/components/Saldo.vue";
import NonConfirmedExpenses from "@/views/reports/components/NonConfirmedExpenses.vue";
import NonConfirmedIncomes from "@/views/reports/components/NonConfirmedIncomes.vue";
import CurrencyExchangeBlock from "@/views/reports/components/CurrencyExchangeBlock.vue";
import Calculation from "@/views/reports/components/Calculation.vue";

export default {
  title: 'Отчет',
  components: {
    Calculation,
    CurrencyExchangeBlock,
    NonConfirmedIncomes,
    NonConfirmedExpenses,
    Saldo,
    IncomesBlock,
    ExpensesBlock,
    LoadingButton,
    DateSelect
  },
  data() {
    return {
      selectedDate: null,
      loading: false,
      reportLoaded: false,
      selectedDivision: -1,
      balance: {},
      allowedData: {},
      incomes: [],
      expenses: [],
      dateRange: {},
      expensesTypes: {},
      exchanges: [],
      allowedCurrencies: {},
      ncAmount: 0,
      reportData: {},
      orders: {},
    }
  },
  computed: {
    $AllCurrencies() {
      return this.$store.getters["platform/currencies"];
    },
  },
  watch: {
    balance: {
      handler: async function (val, oldVal) {
        this.updateNonConfirmedAmount();
      },
      deep: true
    },
  },
  async mounted() {
    if (!this.$route.query.date) {
      this.selectedDate = moment().format('DD.MM.YYYY')
    } else {
      if (this.$route.query.date) {
        this.selectedDate = this.$route.query.date
      }
    }
    const days = this.$UserDetails.find((d) => d.alias === 'runner_report_days')?.details ?? 1;
    this.dateRange = {
      min: moment().subtract(days, 'days').format('YYYY-MM-DD'),
      max: moment().format('YYYY-MM-DD')
    };
    const uDetail = this.$UserDetails.find((d) => d.alias === 'division_id');
    this.selectedDivision = uDetail?.details ?? -1;
    const detail = this.$UserDetails.find((d) => d.alias === 'allowed_expenses_currencies');
    if (detail) {
      this.allowedCurrencies = detail.details.reduce((acc, c) => {
        acc[c] = {...this.$AllCurrencies[c]};
        return acc;
      }, {})
    }
    await this.getExpensesTypes();
    await this.showReport();
    this.updateNonConfirmedAmount();
  },
  methods: {
    async updateExchanges() {

    },
    checkPermission(alias) {
      switch (alias) {
        case 'allowToBuyCurrency':
          return !!Object.keys(this.allowedCurrencies).filter((c) => +c !== 33).length;
      }
      return false;
    },
    updateNonConfirmedAmount() {
      this.ncAmount = (this.balance?.nonConfirmedIncomes ?? []).filter((r) => +r.is_confirmed !== 2).reduce((acc, i) => acc + i.sum, 0);
    },
    async getExpensesTypes() {
      const {data} = await api.index('/reports/expenses/types');
      if (data.success) {
        this.expensesTypes = data.records.reduce((acc, e) => {
          acc[e.id] = e.title;
          return acc;
        }, {})
      }
    },
    async showReport(date = null, newDivId = null, silent = false) {
      this.loading = !silent;
      const strParams = '?date=' + this.selectedDate + '&divId=' + this.selectedDivision + '&ncInc=1';
      const {data} = await api.index('/reports/getReport2' + strParams);
      if (!data.success) {
        toastr['warning'](data.message ?? 'ошибка сервера', 'Неуспешно')
      } else {
        // this.$nextTick(() => {
        const orders = data?.reportData?.orders?.[0] ?? {};
        this.orders = {
          total_currency_clear_price: orders?.c_c_price ?? 0,
          total_pass: orders?.c_price ?? 0
        }
        this.balance = data.balance;
        this.reportData = data.reportData;
        this.expenses = data.reportData.expenses ?? [];
        this.exchanges = data.reportData.exchanges ?? [];
        this.incomes = [...(data.reportData.incomes?.in ?? []), ...(data.reportData.incomes?.out ?? [])];
        // });
      }
      this.reportLoaded = true;
      this.loading = false;
    },
    getAllowedReceivers(type = 'allowed_cashout') {
      const arr = this.$UserDetails.find((d) => d.alias === type)?.details ?? [];
      if (type !== 'allowed_cashout') return arr;
      let division = Object.values(this.$AllDivisions).filter(d => arr.includes(d.id))
      if (arr.includes(0)) division.push({id: 0})
      return division;
    },
    updateSelectedDate() {
      this.selectedDate =
        (this.$refs.selectedDate && this.$refs.selectedDate.date) ||
        moment().format('DD.MM.YYYY')
      this.showReport()
    },
  }
}

</script>

<style scoped>
.report_block {
  position: relative;
}

.loading_block {
  position: absolute;
}

.loading_block.active {
  background-color: white;
  opacity: .7;
  z-index: 9;
  width: 100%;
  height: 100%;
}
</style>
